import { parseResponse } from '$lib/client/responseHelpers';

import { client } from '@api/client';

export const callStart = async (userId: string) => {
    const data =  await client.POST('/call/{userId}/start', {
        params: {
            path: {
                userId,
            },
        },
    });
    return parseResponse(data);
};

export const callAnswer = async (roomId: string) => {
    const data =  await client.POST('/call/{roomId}/answer', {
        params: {
            path: {
                roomId,
            },
        },
    });
    return parseResponse(data);
};

export const callClose = async (roomId: string) => {
    const data =  await client.POST('/call/{roomId}/close', {
        params: {
            path: {
                roomId,
            },
        },
    });
    return parseResponse(data);
};

export const changeCallMuteSettings = async (value: boolean) => {
    const data =  await client.POST('/call/change-mute-settings', {
        body: {
            value,
        },
    });
    return parseResponse(data);
};